export default function usePagination(inputPage: string | undefined): [number, boolean] {
  let page = 1;
  let pageInvalid = false;
  if (inputPage) {
    if (!Number.isNaN(Number.parseInt(inputPage)) && Number.parseInt(inputPage) > 0) {
      page = Number.parseInt(inputPage);
    } else {
      pageInvalid = true;
    }
  }

  return [page, pageInvalid];
}
